module.exports = __webpack_public_path__ + "static/legends-7-111504c5baab28d19e2fd862c932e6be.jpg";